import { render } from "./CaptureModalSell.vue?vue&type=template&id=5bf5a42c"
import script from "./CaptureModalSell.vue?vue&type=script&lang=js"
export * from "./CaptureModalSell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__